// Module: motion.js (components/ds)
// Purpose: Single source of truth for framer-motion physics used across the
//          DS. Mirrors the CSS spring tokens in styles/ds-tokens.css
//          (--spring-snappy / --spring-smooth / --spring-bouncy) — MUST STAY
//          IN SYNC with that file. If you change a stiffness/damping value
//          here, update the matching CSS var comment too, and vice versa.

/** Toggles, tap feedback, button press — ~140ms settle. */
export const SPRING_SNAPPY = { type: "spring", stiffness: 400, damping: 40 };

/** Sheets, panels, page flights — ~200ms settle. */
export const SPRING_SMOOTH = { type: "spring", stiffness: 280, damping: 32 };

/** Playful reveals — empty-state illustrations ONLY, never functional UI. */
export const SPRING_BOUNCY = { type: "spring", stiffness: 320, damping: 22 };

/** Standard whileTap scale — 0.97, never 0.9 (0.9 reads as a "crush", not a tap). */
export const TAP = { scale: 0.97 };
